import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0aa8248f = () => interopDefault(import('../../../pages/account-deletion.vue' /* webpackChunkName: "pages/account-deletion" */))
const _563711c3 = () => interopDefault(import('../../../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _4ca7f806 = () => interopDefault(import('../../../pages/favorites.vue' /* webpackChunkName: "pages/favorites" */))
const _3f1a3796 = () => interopDefault(import('../../../pages/inbox.vue' /* webpackChunkName: "pages/inbox" */))
const _2874334d = () => interopDefault(import('../../../pages/inbox/_messageId.vue' /* webpackChunkName: "pages/inbox/_messageId" */))
const _4b483813 = () => interopDefault(import('../../../pages/login-error.vue' /* webpackChunkName: "pages/login-error" */))
const _0817a5cb = () => interopDefault(import('../../../pages/map.vue' /* webpackChunkName: "pages/map" */))
const _45f4baf4 = () => interopDefault(import('../../../pages/news.vue' /* webpackChunkName: "pages/news" */))
const _75838b12 = () => interopDefault(import('../../../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _09366e9f = () => interopDefault(import('../../../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _086cf5db = () => interopDefault(import('../../../pages/parts-catalog.vue' /* webpackChunkName: "pages/parts-catalog" */))
const _cf26f5ee = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _241960cc = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _67e12634 = () => interopDefault(import('../../../pages/search/_id.vue' /* webpackChunkName: "pages/search/_id" */))
const _02278e1d = () => interopDefault(import('../../../pages/search/_id/documents.vue' /* webpackChunkName: "pages/search/_id/documents" */))
const _1894ec90 = () => interopDefault(import('../../../pages/search/_id/maintenance.vue' /* webpackChunkName: "pages/search/_id/maintenance" */))
const _14683b77 = () => interopDefault(import('../../../pages/search/_id/messages.vue' /* webpackChunkName: "pages/search/_id/messages" */))
const _115f3756 = () => interopDefault(import('../../../pages/search/_id/parameters.vue' /* webpackChunkName: "pages/search/_id/parameters" */))
const _f1fbd078 = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _4410578c = () => interopDefault(import('../../../pages/settings/organization/_organizationId.vue' /* webpackChunkName: "pages/settings/organization/_organizationId" */))
const _266630e2 = () => interopDefault(import('../../../pages/settings/organization/_organizationId/create.vue' /* webpackChunkName: "pages/settings/organization/_organizationId/create" */))
const _62c7c05d = () => interopDefault(import('../../../pages/settings/organization/_organizationId/edit.vue' /* webpackChunkName: "pages/settings/organization/_organizationId/edit" */))
const _b738ede0 = () => interopDefault(import('../../../pages/settings/organization/_organizationId/edit/details.vue' /* webpackChunkName: "pages/settings/organization/_organizationId/edit/details" */))
const _71141c67 = () => interopDefault(import('../../../pages/settings/organization/_organizationId/edit/members.vue' /* webpackChunkName: "pages/settings/organization/_organizationId/edit/members" */))
const _0298a744 = () => interopDefault(import('../../../pages/settings/organization/_organizationId/edit/subscriptions.vue' /* webpackChunkName: "pages/settings/organization/_organizationId/edit/subscriptions" */))
const _873bbbb4 = () => interopDefault(import('../../../pages/things.vue' /* webpackChunkName: "pages/things" */))
const _4e23fe3a = () => interopDefault(import('../../../pages/things/_thingId.vue' /* webpackChunkName: "pages/things/_thingId" */))
const _d8ef3830 = () => interopDefault(import('../../../pages/things/_thingId/dashboard.vue' /* webpackChunkName: "pages/things/_thingId/dashboard" */))
const _1cc21a0c = () => interopDefault(import('../../../pages/things/_thingId/documents.vue' /* webpackChunkName: "pages/things/_thingId/documents" */))
const _5c465432 = () => interopDefault(import('../../../pages/things/_thingId/maintenance.vue' /* webpackChunkName: "pages/things/_thingId/maintenance" */))
const _4698edec = () => interopDefault(import('../../../pages/things/_thingId/maintenance/history.vue' /* webpackChunkName: "pages/things/_thingId/maintenance/history" */))
const _cd3614b0 = () => interopDefault(import('../../../pages/things/_thingId/messages.vue' /* webpackChunkName: "pages/things/_thingId/messages" */))
const _30075646 = () => interopDefault(import('../../../pages/things/_thingId/parameters.vue' /* webpackChunkName: "pages/things/_thingId/parameters" */))
const _26b3dff8 = () => interopDefault(import('../../../pages/things/_thingId/service-partner.vue' /* webpackChunkName: "pages/things/_thingId/service-partner" */))
const _d0a1355e = () => interopDefault(import('../../../pages/welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _eb325992 = () => interopDefault(import('../../../pages/plates/error.vue' /* webpackChunkName: "pages/plates/error" */))
const _4a8f311e = () => interopDefault(import('../../../pages/plates/scan.vue' /* webpackChunkName: "pages/plates/scan" */))
const _a61994f4 = () => interopDefault(import('../../../pages/user/profile.vue' /* webpackChunkName: "pages/user/profile" */))
const _27858da7 = () => interopDefault(import('../../../pages/warranty/things.vue' /* webpackChunkName: "pages/warranty/things" */))
const _1464faea = () => interopDefault(import('../../../pages/warranty/things/index.vue' /* webpackChunkName: "pages/warranty/things/index" */))
const _3be8afd2 = () => interopDefault(import('../../../pages/warranty/things/_id.vue' /* webpackChunkName: "pages/warranty/things/_id" */))
const _023e2a3b = () => interopDefault(import('../../../pages/warranty/things/_id/documents.vue' /* webpackChunkName: "pages/warranty/things/_id/documents" */))
const _392ee481 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0ee60290 = () => interopDefault(import('../../../pages/plates/_hibc.vue' /* webpackChunkName: "pages/plates/_hibc" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account-deletion",
    component: _0aa8248f,
    meta: {"isRootPath":true},
    name: "account-deletion"
  }, {
    path: "/dashboard",
    component: _563711c3,
    meta: {"isRootPath":true},
    name: "dashboard"
  }, {
    path: "/favorites",
    component: _4ca7f806,
    meta: {"isRootPath":true},
    name: "favorites"
  }, {
    path: "/inbox",
    component: _3f1a3796,
    meta: {"isRootPath":true},
    name: "inbox",
    children: [{
      path: ":messageId?",
      component: _2874334d,
      meta: {"isRootPath":false},
      name: "inbox-messageId"
    }]
  }, {
    path: "/login-error",
    component: _4b483813,
    meta: {"isRootPath":true},
    name: "login-error"
  }, {
    path: "/map",
    component: _0817a5cb,
    meta: {"isRootPath":true},
    name: "map"
  }, {
    path: "/news",
    component: _45f4baf4,
    meta: {"isRootPath":true},
    children: [{
      path: "",
      component: _75838b12,
      meta: {"isRootPath":true},
      name: "news"
    }, {
      path: ":id",
      component: _09366e9f,
      meta: {"isRootPath":false},
      name: "news-id"
    }]
  }, {
    path: "/parts-catalog",
    component: _086cf5db,
    meta: {"isRootPath":true},
    name: "parts-catalog"
  }, {
    path: "/search",
    component: _cf26f5ee,
    meta: {"isRootPath":true},
    children: [{
      path: "",
      component: _241960cc,
      meta: {"isRootPath":true},
      name: "search"
    }, {
      path: ":id",
      component: _67e12634,
      meta: {"isRootPath":false},
      name: "search-id",
      children: [{
        path: "documents",
        component: _02278e1d,
        meta: {"isRootPath":false},
        name: "search-id-documents"
      }, {
        path: "maintenance",
        component: _1894ec90,
        meta: {"isRootPath":false},
        name: "search-id-maintenance"
      }, {
        path: "messages",
        component: _14683b77,
        meta: {"isRootPath":false},
        name: "search-id-messages"
      }, {
        path: "parameters",
        component: _115f3756,
        meta: {"isRootPath":false},
        name: "search-id-parameters"
      }]
    }]
  }, {
    path: "/settings",
    component: _f1fbd078,
    meta: {"isRootPath":true},
    name: "settings",
    children: [{
      path: "organization/:organizationId?",
      component: _4410578c,
      meta: {"isRootPath":false},
      name: "settings-organization-organizationId",
      children: [{
        path: "create",
        component: _266630e2,
        meta: {"isRootPath":false},
        name: "settings-organization-organizationId-create"
      }, {
        path: "edit",
        component: _62c7c05d,
        meta: {"isRootPath":false},
        name: "settings-organization-organizationId-edit",
        children: [{
          path: "details",
          component: _b738ede0,
          meta: {"isRootPath":false},
          name: "settings-organization-organizationId-edit-details"
        }, {
          path: "members",
          component: _71141c67,
          meta: {"isRootPath":false},
          name: "settings-organization-organizationId-edit-members"
        }, {
          path: "subscriptions",
          component: _0298a744,
          meta: {"isRootPath":false},
          name: "settings-organization-organizationId-edit-subscriptions"
        }]
      }]
    }]
  }, {
    path: "/things",
    component: _873bbbb4,
    meta: {"isRootPath":true},
    name: "things",
    children: [{
      path: ":thingId?",
      component: _4e23fe3a,
      meta: {"isRootPath":false},
      name: "things-thingId",
      children: [{
        path: "dashboard",
        component: _d8ef3830,
        meta: {"isRootPath":false},
        name: "things-thingId-dashboard"
      }, {
        path: "documents",
        component: _1cc21a0c,
        meta: {"isRootPath":false},
        name: "things-thingId-documents"
      }, {
        path: "maintenance",
        component: _5c465432,
        meta: {"isRootPath":false},
        name: "things-thingId-maintenance",
        children: [{
          path: "history",
          component: _4698edec,
          meta: {"isRootPath":false},
          name: "things-thingId-maintenance-history"
        }]
      }, {
        path: "messages",
        component: _cd3614b0,
        meta: {"isRootPath":false},
        name: "things-thingId-messages"
      }, {
        path: "parameters",
        component: _30075646,
        meta: {"isRootPath":false},
        name: "things-thingId-parameters"
      }, {
        path: "service-partner",
        component: _26b3dff8,
        meta: {"isRootPath":false},
        name: "things-thingId-service-partner"
      }]
    }]
  }, {
    path: "/welcome",
    component: _d0a1355e,
    meta: {"isRootPath":true},
    name: "welcome"
  }, {
    path: "/plates/error",
    component: _eb325992,
    meta: {"isRootPath":true},
    name: "plates-error"
  }, {
    path: "/plates/scan",
    component: _4a8f311e,
    meta: {"isRootPath":true},
    name: "plates-scan"
  }, {
    path: "/user/profile",
    component: _a61994f4,
    meta: {"isRootPath":true},
    name: "user-profile"
  }, {
    path: "/warranty/things",
    component: _27858da7,
    meta: {"isRootPath":true},
    children: [{
      path: "",
      component: _1464faea,
      meta: {"isRootPath":true},
      name: "warranty-things"
    }, {
      path: ":id",
      component: _3be8afd2,
      meta: {"isRootPath":false},
      name: "warranty-things-id",
      children: [{
        path: "documents",
        component: _023e2a3b,
        meta: {"isRootPath":false},
        name: "warranty-things-id-documents"
      }]
    }]
  }, {
    path: "/",
    component: _392ee481,
    meta: {"isRootPath":true},
    name: "index"
  }, {
    path: "/plates/:hibc?",
    component: _0ee60290,
    meta: {"isRootPath":true},
    name: "plates-hibc"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
